import { render } from "./ModalProcuradorFI.vue?vue&type=template&id=ee19cb6c"
import script from "./ModalProcuradorFI.vue?vue&type=script&lang=js"
export * from "./ModalProcuradorFI.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__